/**
 * Create a simple error helper for a pair of DOM elements.
 *
 * @param {HTMLInputElement|HTMLElement} inputEl  – the <input> or other form control
 * @param {HTMLElement} errorEl                  – the element that shows the error message
 * @returns {{ error: (msg: string) => void, clear: () => void, destroy: () => void }}
 */
function errorHelper(inputEl, errorEl) {
  // initial state
  errorEl.style.display = 'none';
  errorEl.textContent = '';
  inputEl.setAttribute('aria-invalid', 'false');

  // clear function
  function clear() {
    errorEl.textContent = '';
    errorEl.style.display = 'none';
    inputEl.classList.remove('error');
    inputEl.setAttribute('aria-invalid', 'false');
  }

  // show error function
  function error(message) {
    errorEl.textContent = message;
    errorEl.style.display = 'block';
    inputEl.classList.add('error');
    inputEl.setAttribute('aria-invalid', 'true');
  }

  // auto‐clear on user input
  const onInput = () => clear();
  inputEl.addEventListener('input', onInput);

  // allow cleanup if needed
  function destroy() {
    inputEl.removeEventListener('input', onInput);
  }

  return { error, clear, destroy };
}

export default errorHelper;
